import script from "./business-license-input.vue?vue&type=script&lang=ts&setup=true"
export * from "./business-license-input.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__